import axios from "axios";

const API_URL = process.env.REACT_APP_HUB_API_URL || "http://localhost:4100";

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// Interceptor para adicionar API Key ou JWT
api.interceptors.request.use((config) => {
  const apiKey = localStorage.getItem("hub_api_key");
  const token = localStorage.getItem("hub_token");

  if (apiKey) {
    config.headers["X-Hub-Api-Key"] = apiKey;
  } else if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

// ===== API Methods =====

export const hubApi = {
  // Licença e plano
  getLicense: () => api.get("/hub/license"),

  // Canais disponíveis
  getChannels: () => api.get("/hub/channels"),

  // Conexões
  getConnections: () => api.get("/hub/connections"),

  // Config Meta
  getMetaConfig: () => api.get("/hub/meta-config"),

  // Meta Embedded Signup
  metaEmbeddedSignup: (code, channel) =>
    api.post("/hub/meta-embedded-signup", { code, channel }),

  // Telegram (Bot Token)
  telegramConnect: (botToken, name) =>
    api.post("/hub/telegram-connect", { botToken, name }),

  // Telegram (Número Pessoal — MTProto)
  telegramPhoneConnect: (phoneNumber, name) =>
    api.post("/hub/telegram-connect", { phoneNumber, name }),
  telegramVerifyCode: (connectionId, code, phoneCodeHash) =>
    api.post("/hub/telegram-verify-code", { connectionId, code, phoneCodeHash }),
  telegramVerify2FA: (connectionId, password) =>
    api.post("/hub/telegram-verify-2fa", { connectionId, password }),

  // Email
  emailConnect: (params) => api.post("/hub/email-connect", params),

  emailDisconnect: (connectionId) =>
    api.post("/hub/email-disconnect", { connectionId }),

  // Desconectar conexão (mantém registro)
  disconnectConnection: (id) => api.post(`/hub/connections/${id}/disconnect`),

  // Reconectar conexão existente
  reconnectConnection: (id) => api.post(`/hub/connections/${id}/reconnect`),

  // Remover conexão permanentemente
  deleteConnection: (id) => api.delete(`/hub/connections/${id}`),

  // Enviar mensagem
  sendMessage: (connectionId, to, message) =>
    api.post("/hub/send", { connectionId, to, message }),

  // Portal redirect (marketplace)
  getPortalRedirect: (channel) =>
    api.get("/hub/portal-redirect", { params: { channel } }),

  // ===== VoIP =====
  voipConnect: (params) => api.post("/hub/voip/connect", params),
  voipGetConfig: (connectionId) => api.get(`/hub/voip/config/${connectionId}`),
  voipUpdateConfig: (connectionId, config) =>
    api.put(`/hub/voip/config/${connectionId}`, config),
  voipGetDashboard: (period = "30d") =>
    api.get("/hub/voip/dashboard", { params: { period } }),
  voipGetCallHistory: (params) =>
    api.get("/hub/voip/calls", { params }),
  voipGetCallDetail: (id) => api.get(`/hub/voip/calls/${id}`),
  voipGetRecording: (id) => `${API_URL}/hub/voip/calls/${id}/recording`,
  voipInitiateCall: (params) => api.post("/hub/voip/call/initiate", params),
  voipHangup: (callId) => api.post(`/hub/voip/call/${callId}/hangup`),
  voipTransfer: (callId, to) =>
    api.post(`/hub/voip/call/${callId}/transfer`, { to }),
  voipHold: (callId, hold = true) =>
    api.post(`/hub/voip/call/${callId}/hold`, { hold }),
  voipGetSIPCredentials: (connectionId, reveal = false) =>
    api.get(`/hub/voip/sip-credentials/${connectionId}`, {
      params: { reveal: reveal ? "true" : "false" },
    }),

  // ===== SIP Trunk =====
  sipConnect: (params) => api.post("/hub/sip/connect", params),
  sipDisconnect: (connectionId) =>
    api.post(`/hub/sip/disconnect/${connectionId}`),
  sipTest: (connectionId) => api.post(`/hub/sip/test/${connectionId}`),
  sipRegisterCall: (params) => api.post("/hub/sip/call/register", params),
  sipUpdateCallStatus: (callId, status, extra) =>
    api.post(`/hub/sip/call/${callId}/status`, { status, ...extra }),

  // ===== Connect Dashboard =====
  getDashboard: () => api.get("/hub/dashboard"),
  getDispatchMetrics: () => api.get("/hub/metrics/dispatch"),

  // ===== HUBs Locais =====
  getHubList: () => api.get("/hub/local/list"),
  deleteHub: (hubId) => api.delete(`/hub/local/${hubId}`),

  // ===== Settings =====
  getSettings: () => api.get("/hub/settings"),
  updateSetting: (key, value) => api.put("/hub/settings", { key, value }),
  testService: (service) => api.post(`/hub/settings/test/${service}`),

  // ===== White Label =====
  getWhiteLabel: () => api.get("/hub/whitelabel"),
  updateWhiteLabel: (config) => api.put("/hub/whitelabel", config),

  // ===== Portal =====
  getPortalRedirect: (channel) =>
    api.get("/hub/portal-redirect", { params: { channel } }),
};

export default hubApi;
